// Knappen "Designa din egen": öppnar Kentuckys designverktyg för den variant kunden har valt.
// Temaversionen: snippeten ritar knappen sist på sidan, och skriptet flyttar den direkt under köpformuläret.
// Klicket fångas på dokumentet, eftersom temat (Essence) ritar om produktdelen när kunden byter variant.
(function () {
  'use strict';

  if (window.__aranaButton) return;
  window.__aranaButton = true;

  // Köpformuläret, inte t.ex. temats delbetalningsformulär (Essence har båda).
  function productForm(scope) {
    return scope.querySelector('form[data-type="add-to-cart-form"]') ||
      scope.querySelector('form.product-form[action*="/cart/add"]') ||
      Array.prototype.find.call(scope.querySelectorAll('form[action*="/cart/add"]'), function (form) {
        // getAttribute, eftersom form.id ger fältet som heter "id" när formuläret har ett sådant.
        return !/installment/i.test(form.getAttribute('id') || '');
      });
  }

  // Exakt det variant-id som köpknappen skulle skicka. FormData räknar med fält som hör till formuläret via
  // attributet form="…" och hoppar över avstängda fält.
  function selectedVariantId(container) {
    var form = productForm(container.closest('.shopify-section') || document) || productForm(document);
    var id = form ? new FormData(form).get('id') : null;
    if (id) return String(id);
    return new URLSearchParams(window.location.search).get('variant') || container.dataset.defaultVariant;
  }

  // Lägger knappen direkt efter köpformuläret. Ritar temat om produktdelen följer knappen med det nya formuläret.
  var box = document.querySelector('[data-arana-place]');
  function place() {
    if (!box) return;
    var form = productForm(document);
    if (form && box.previousElementSibling !== form) {
      form.parentNode.insertBefore(box, form.nextSibling);
    } else if (!form && !box.isConnected) {
      document.body.appendChild(box);
    }
    box.hidden = false;
  }
  if (box) {
    place();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        var form = productForm(document);
        if (!box.isConnected || (form && box.previousElementSibling !== form)) place();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-arana-link]');
    if (!link) return;
    var container = link.closest('[data-arana-design]');
    if (!container) return;
    event.preventDefault();

    var variants = JSON.parse(container.querySelector('[data-arana-variants]').textContent);
    var variant = variants[selectedVariantId(container)] || variants[container.dataset.defaultVariant];
    if (!variant || (!variant.sku && !variant.ean)) {
      window.alert('Den här varianten kan inte designas. Kontakta oss så hjälper vi dig.');
      return;
    }
    if (variant.ok === false) {
      window.alert('Den här färgen eller storleken går inte att designa. Välj en annan variant av produkten.');
      return;
    }
    // EAN i första hand (Kentuckys rekommendation: butikens SKU:er är inte alltid Kentuckys).
    var params = new URLSearchParams();
    if (variant.ean) params.set('ean', variant.ean);
    else params.set('sku', variant.sku);
    params.set('partner', container.dataset.partner);
    params.set('language', container.dataset.language || 'en');
    // Butikens valuta (Kentucky visar SEK, NOK, DKK och EUR; okända valutor blir EUR).
    if (container.dataset.currency) params.set('currency', container.dataset.currency);
    params.set('source_url', container.dataset.sourceUrl);
    window.location.href = container.dataset.configurator + '?' + params.toString();
  });
})();
